import { render, staticRenderFns } from "./CounselingForm.vue?vue&type=template&id=59e469a4&scoped=true"
import script from "./CounselingForm.vue?vue&type=script&lang=js"
export * from "./CounselingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e469a4",
  null
  
)

export default component.exports